import {
  useCreateCodelistValuesMutation,
  useGetCodelistLibraryMutation,
  useGetCodelistValueCodesMutation,
  useGetCodelistValueMutation,
  useUpdateCodelistValuesMutation,
} from "../store/services/codelistQuery";

export const useCodelist = () => {
  const [
    getCodelistData,
    {
      data: codelistData,
      isLoading: codelistIsLoading,
      isError: codelistIsError,
      error: codelistError,
      isSuccess: codelistIsSuccess,
    },
  ] = useGetCodelistValueMutation();
  const [
    getAllCodelists,
    {
      data: allCodelistData,
      isLoading: allCodelistIsLoading,
      isError: allCodelistIsError,
      error: allCodelistError,
      isSuccess: allCodelistIsSuccess,
    },
  ] = useGetCodelistLibraryMutation();
  const [
    getCodelistValues,
    {
      data: codelistValuesData,
      isLoading: codelistValuesIsLoading,
      isError: codelistValuesIsError,
      error: codelistValuesError,
      isSuccess: codelistValuesIsSuccess,
    },
  ] = useGetCodelistValueCodesMutation();
  const [
    createCodelistValues,
    {
      data: createCodelistValuesData,
      isLoading: createCodelistValuesIsLoading,
      isError: createCodelistValuesIsError,
      error: createCodelistValuesError,
      isSuccess: createCodelistValuesIsSuccess,
    },
  ] = useCreateCodelistValuesMutation();
  const [
    updateCodelistValues,
    {
      data: updateCodelistValuesData,
      isLoading: updateCodelistValuesIsLoading,
      isError: updateCodelistValuesIsError,
      error: updateCodelistValuesError,
      isSuccess: updateCodelistValuesIsSuccess,
    },
  ] = useUpdateCodelistValuesMutation();
  return {
    getCodelistData,
    codelistData,
    codelistIsLoading,
    codelistIsError,
    codelistError,
    codelistIsSuccess,
    getAllCodelists,
    allCodelistData,
    allCodelistIsLoading,
    allCodelistIsError,
    allCodelistError,
    allCodelistIsSuccess,
    getCodelistValues,
    codelistValuesData,
    codelistValuesIsLoading,
    codelistValuesIsError,
    codelistValuesError,
    codelistValuesIsSuccess,
    createCodelistValues,
    createCodelistValuesData,
    createCodelistValuesIsLoading,
    createCodelistValuesIsError,
    createCodelistValuesError,
    createCodelistValuesIsSuccess,
    updateCodelistValues,
    updateCodelistValuesData,
    updateCodelistValuesIsLoading,
    updateCodelistValuesIsError,
    updateCodelistValuesError,
    updateCodelistValuesIsSuccess,
  };
};
